<template>
    <div v-if="activities">
    <div class="loader" v-if="loading"></div>
    <time-line type="one-side" :key="activity.id" v-for="activity in activities" >
        <time-line-item badge-type="success" badge-icon="ni ni-bell-55">
                <small class="text-muted font-weight-bold">{{ formatDate(activity.created_at) }}</small>
                <h5 class=" mt-3 mb-0">{{ activity.title }}</h5>
                <p class=" text-sm mt-1 mb-0">{{ activity.body }}</p>

                <!-- div class="mt-3">
                  <badge rounded type="success">design</badge>&nbsp;
                  <badge rounded type="success">system</badge>&nbsp;
                  <badge rounded type="success">creative</badge>
                </div -->

        </time-line-item>      
    </time-line>
  </div>
  </template>
  
<script>

import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { TimeLine, TimeLineItem } from '@/components';
import Badge from '@/components/Badge';
import moment from 'moment'

import AppStyle from '@/plugins/appStyle';

export default {
  mixins: [AppStyle.Mixin],
    name: 'damage-history',
    components: {
      RouteBreadCrumb,
      Badge,
      TimeLine,
      TimeLineItem,
    },
  data () {
    return {
      loading: false,
      activities: [],
    }
  },
  props: {
    id: String,
    type: String,
  },
  methods: {
    retrieveHistory(){
      if(this.type == 'claim'){
        return this.retrieveClaimHistory();
      }
      if(this.type == 'cost_estimate'){
        return this.retrieveCostEstimateHistory();
      }
    },
    retrieveClaimHistory() {
      this.loading = true;
      this.$api.getClaimActivities(this.id).then(response => {
          this.activities = response.data.activities;
        })
        .catch((e) => {
          console.log(e);
        }).finally(() => {
          this.loading = false
        });
    },
    retrieveCostEstimateHistory() {
      this.loading = true;
      this.$api.getCostEstimateActivities(this.id).then(response => {
          this.activities = response.data.activities;
        })
        .catch((e) => {
          console.log(e);
        }).finally(() => {
          this.loading = false
        });
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY")
    },
  },
  computed: {
  },
  mounted() {
    this.retrieveHistory();
  },
  created() {
  },
}
</script>